module.exports = require("!!vue-loader!../../node_modules/_vue-markdown-loader@2.4.1@vue-markdown-loader/lib/markdown-compiler.js?raw!./iconfont.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/iconfont.md
// module id = 3pvG
// module chunks = 0